import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import './ReportParam.css'
import { useTranslation } from 'react-i18next'

type Props = {
  value: Date | string
  id: string
  onChange: (value: Date | string) => void
}

function ReportParam(props: Props) {
  const [theDate, setTheDate] = useState<Date | undefined>(undefined)
  const { i18n } = useTranslation(['global'])

  function selectDate(date: Date | [Date, Date] | null) {
    if (date instanceof Date) {
      setTheDate(date)
      props.onChange(date)
    } else {
      setTheDate(undefined)
      props.onChange('')
    }
  }

  useEffect(() => {
    if (props.value && props.value instanceof Date) {
      setTheDate(props.value)
    }
  }, [props.value])

  return (
    <DatePicker dateFormat="dd/MM/yyyy" locale={i18n.language} selected={theDate} onChange={date => selectDate(date)} popperModifiers={{
      preventOverflow: {
        enabled: true
      }
    }} />
  )
}

export default ReportParam
